export const groupInstruments = (instruments) => ({
    metrics: instruments.filter(isMetricInstrument),
    chart: instruments.find(isChartInstrument),
    heatmap: instruments.find(isHeatmapInstrument),
    table: instruments.find(isTableInstrument),
    presence: instruments.find(isPresenceInstrument),
});
export const isMetricInstrument = (instrument) => instrument.type === 'metric';
export const isChartInstrument = (instrument) => instrument.type === 'chart' && instrument.visualization !== 'heatmap';
export const isHeatmapInstrument = (instrument) => instrument.type === 'chart' && instrument.visualization === 'heatmap';
export const isTableInstrument = (instrument) => instrument.type === 'table';
export const isPresenceInstrument = (instrument) => instrument.type === 'presence';
export const isInsightInstrument = (instrument) => instrument.type === 'ai_insight';
